import { Button, Typography, Avatar } from "antd";
import { useTenantStore } from "@/state/tenant_state";

const { Text } = Typography;

export default function TenantSwitcher({ collapsed }: { collapsed: boolean }) {
  const { selectedTenant, setSelectedTenant } = useTenantStore();

  function handleClick() {
    // Clear selected tenant to go back to tenant selection screen
    setSelectedTenant(null);
    //window.location.reload()
  }

  if (!selectedTenant) {
    return null; // Don't show if no tenant is selected
  }

  if (collapsed) {
    return (
      <Avatar
        size={32}
        style={{
          objectFit: "fill",
          marginLeft: "9px",
          marginBottom: "15px",
        }}
        onClick={handleClick}
      >
        <img
          src={selectedTenant.tenant.logoUrl}
          alt={selectedTenant.tenant.name}
          style={{ objectFit: "fill" }}
        />
      </Avatar>
    );
  }

  return (
    <div style={{ margin: "0px 5px 15px 5px" }}>
      <Button
        style={{
          width: "100%",
          height: "auto",
          padding: "5px",
          textAlign: "left",
        }}
        type="text"
        onClick={handleClick}
      >
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Avatar
            size={32}
            style={{
              marginRight: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              objectFit: "fill",
            }}
          >
            <img
              src={selectedTenant.tenant.logoUrl}
              alt={selectedTenant.tenant.name}
              style={{ objectFit: "fill" }}
            />
          </Avatar>

          <div style={{ flex: 1, minWidth: 0 }}>
            <Text
              type="secondary"
              style={{
                fontSize: "11px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              Klicken zum Wechseln
            </Text>
            <div
              style={{
                fontWeight: 500,
                marginBottom: 2,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {selectedTenant.tenant.name}
            </div>
          </div>
        </div>
      </Button>
    </div>
  );
}
